import React from 'react';
import { Clock, XCircle } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { useAuth } from '../../contexts/AuthContext';

export default function PendingApprovalScreen({ reason }) {
  const { t } = useLanguage();
  const { logout, userProfile } = useAuth();
  const isRejected = reason === 'rejected';

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100 p-4">
      <div className="w-full max-w-lg bg-white rounded-xl shadow-lg p-8 text-center space-y-4">
        <div className="flex justify-center">
          {isRejected ? (
            <XCircle className="w-14 h-14 text-red-500" aria-hidden />
          ) : (
            <Clock className="w-14 h-14 text-amber-500" aria-hidden />
          )}
        </div>
        <h1 className="text-xl font-semibold text-gray-900">
          {isRejected ? t('approval.rejected.title') : t('approval.pending.title')}
        </h1>
        <p className="text-sm text-gray-600 leading-relaxed">
          {isRejected ? t('approval.rejected.message') : t('approval.pending.message')}
        </p>
        {!isRejected && userProfile?.persona ? (
          <p className="text-xs text-gray-500">
            {t('approval.pending.requestedType')}:{' '}
            <span className="font-medium">{t(`persona.${userProfile.persona}`)}</span>
          </p>
        ) : null}
        {userProfile?.personaRejectionReason ? (
          <p className="text-sm text-red-700 bg-red-50 rounded-lg p-3 text-left">
            {userProfile.personaRejectionReason}
          </p>
        ) : null}
        <div className="flex flex-col sm:flex-row gap-2 justify-center pt-2">
          <button
            type="button"
            onClick={() => logout?.()}
            className="px-4 py-2 border border-gray-300 rounded-lg text-sm hover:bg-gray-50"
          >
            {t('auth.logout')}
          </button>
        </div>
      </div>
    </div>
  );
}
